// angular
import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '../../../app.service';
import { MeRegisterService } from '../me-register.service';
import * as moment from 'moment';
import * as _ from 'lodash';

@Component({
    selector: 'me-register-form',
    templateUrl: './register-form.component.html',
    styleUrls: ['./register-form.component.scss']
})

export class MeRegisterFormComponent implements OnInit {
    form: FormGroup;
    genders = [
        {
            name : 'Female',
            value: 2
        },
        {
            name : 'Male',
            value: 1
        },
        {
            name : 'Non-binary',
            value: 3
        }
    ];
    submitted = false;
    errorAge = false;
    errorMessage = '';
    dateFormat: string = 'DD.MM.YYYY';
    invalidEmail = false;

    constructor(
        public appService: AppService,
        public fb: FormBuilder,
        public meRegisterService: MeRegisterService,
        public translate: TranslateService
    ) {

    }

    ngOnInit() {
        this.form = this.fb.group({
            name: ['', [Validators.required]],
            surname: ['', [Validators.required]],
            email: ['', [Validators.required, Validators.pattern('[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}')]],
            birthday: ['', [Validators.required]],
            gender: ['']
        });

        // 7274
        this.form.get('email').valueChanges.subscribe(res => {
            this.invalidEmail = false;
        });
    }

    submit(data, isValid) {
        this.submitted = true;
        if (!isValid || this.errorAge) {
            return;
        }

        data['no_email'] = true;
        data['is_b2c'] = true;
        data['is_me'] = true;
        data['birthday'] = moment(data['birthday']).format(this.dateFormat);
        let language = _.find(this.appService.meLanguages, {locale: this.translate.currentLang});
        data['language_id'] = language.id;
        data['token']= this.appService.getMeClinicVoucher();

        let registerToken = localStorage.getItem('registerToken');
        if (registerToken && registerToken !== '') {
            data['jwt_token'] = registerToken;
        }

        let flatform = this.appService.getMeClinicFlatform();
        if (flatform && flatform !== '') {
            data['register_platform'] = flatform;
        }


        this.appService.isLoading = true;
        this.meRegisterService.register(data, this.appService.getMeClinicId()).subscribe((res) => {
            this.appService.isLoading = false;
            this.submitted = false;
            this.meRegisterService.patientEmail = data['email'];
            this.meRegisterService.step = 5;
            localStorage.removeItem('registerToken');
            localStorage.removeItem('meClinicFlatform');
        },
        (error) => {
            this.appService.isLoading = false;
            this.errorMessage = error.error.error;
            this.invalidEmail = true;
        });
    }

     onBirthdayChanged(value) {
        const birthday = moment(value);
        let age = Math.abs(birthday.diff(moment(), 'years'));
        this.errorAge = age >= 18 ? false : true;
    }

    selectGender(value) {
        this.form.controls.gender.setValue(value);
    }
}
